import { Loader2 } from "lucide-react";

import { useScreen0Messages } from "@/i18n";

export function QueryLoading({ label }: { label?: string }) {
  const t = useScreen0Messages();
  const resolvedLabel = label ?? t.query.loadingDefault;

  return (
    <div className="liquid-glass-panel flex items-center gap-3 p-5">
      <Loader2 size={20} className="animate-spin" />
      <p className="text-sm">{resolvedLabel}</p>
    </div>
  );
}

export function QueryEmpty({ title, body }: { title: string; body: string }) {
  return (
    <div className="liquid-glass-panel grid gap-2 p-5">
      <h2 className="text-xl font-semibold">{title}</h2>
      <p className="text-sm leading-6 text-[oklch(72%_0.025_155)]">{body}</p>
    </div>
  );
}

export function QueryError({ message, title }: { message: string; title?: string }) {
  const t = useScreen0Messages();

  return (
    <div className="liquid-glass-alert grid gap-2 p-5 text-[oklch(88%_0.025_35)]">
      <h2 className="text-xl font-semibold">{title ?? t.query.errorTitle}</h2>
      <p className="text-sm leading-6">{message}</p>
    </div>
  );
}
